<section
    class="upgrade-promotion"
    [class.upgrade-promotion--confirmed]="confirmed"
    *ngIf="updateSummary?.category"
>
    <span class="upgrade-promotion__curtain" aria-hidden="true"></span>
    <div class="upgrade-promotion__header">
        <img alt="" [src]="'images/start-extras.svg' | cdn" />
        <ng-container *ngIf="!confirmed; else headerConfirmed">
            <span class="d-none d-md-inline">{{
                'fe_details_step3_main_wrapper_footer_title_upgrade_car'
                    | translate
            }}</span>
            <span class="d-inline d-md-none">{{
                'fe_details_step3_main_wrapper_footer_title_upgrade_car_mobile'
                    | translate
            }}</span>
        </ng-container>
        <ng-template #headerConfirmed>
            <span>{{
                'fe_details_step3_main_wrapper_footer_title_upgrade_car_confirmed'
                    | translate
            }}</span>
        </ng-template>
    </div>
    <div class="container">
        <div class="upgrade-promotion__images">
            <div class="upgrade-promotion__origin">
                <div class="upgrade-promotion__stage">
                    <img
                        alt="img-automovil"
                        class="card__img"
                        [src]="updateSummary?.category?.img"
                    />
                </div>
                <h4>{{ updateSummary?.category?.name }}</h4>
                <p *ngIf="!confirmed; else originModel">
                    {{ 'fe_details_upgrade_promotion_info_select' | translate }}
                </p>
                <ng-template #originModel>
                    <p *ngIf="updateSummary?.category?.model">
                        ({{ updateSummary?.category?.model }})
                    </p>
                </ng-template>
            </div>
            <div class="upgrade-promotion__arrow">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                    <path
                        d="M204 280L392 280L392 128L620 320L392 512L392 360L204 360Z"
                    />
                </svg>
            </div>

            <div class="upgrade-promotion__origin">
                <div class="upgrade-promotion__stage">
                    <picture>
                        <img
                            class="upgrade-promotion__star upgrade-promotion__star--top"
                            [src]="'images/starts.svg' | cdn"
                            alt=""
                        />
                        <img
                            alt="img-automovil"
                            class="card__img"
                            [src]="updateSummary?.categoryUpdate?.img"
                        />
                        <img
                            class="upgrade-promotion__star upgrade-promotion__star--bottom"
                            [src]="'images/down_starts.svg' | cdn"
                            alt=""
                        />
                        <span class="upgrade-promotion__tag">
                            <svg viewBox="0 0 24 24" aria-hidden="true">
                                <path
                                    d="M12 2l2.9 6.3 6.9.8-5.1 4.7 1.4 6.8L12 17.3 5.9 20.6l1.4-6.8L2.2 9.1l6.9-.8z"
                                />
                            </svg>
                            {{
                                'featured_details_updateCategory_tag'
                                    | translate
                            }}
                        </span>
                    </picture>
                </div>
                <h4>{{ updateSummary?.categoryUpdate?.name }}</h4>
                <p *ngIf="!confirmed; else updateSelected">
                    ({{ updateSummary?.categoryUpdate?.model }})
                </p>
                <ng-template #updateSelected>
                    <p>
                        {{
                            'fe_details_upgrade_promotion_info_select'
                                | translate
                        }}
                    </p>
                </ng-template>
            </div>
        </div>
        <div class="upgrade-promotion__info">
            <p>
                <strong
                    >{{
                        (confirmed
                            ? 'featured_details_updateCategory_title_confirmed'
                            : 'featured_details_updateCategory_1'
                        ) | translate
                    }}
                    {{ updateSummary?.categoryUpdate?.name }}</strong
                >
                <span
                    class="upgrade-promotion__price"
                    *ngIf="!confirmed; else priceConfirmed"
                    >{{ 'featured_details_updateCategory_2' | translate }} ${{
                        updateSummary?.priceDifference
                            | formatNumber: '$' : false
                    }}
                    {{
                        'featured_details_updateCategory_3_more' | translate
                    }}</span
                >
                <ng-template #priceConfirmed>
                    <span class="upgrade-promotion__price">
                        {{
                            'featured_details_updateCategory_price_confirmed'
                                | translate
                        }}
                        ${{
                            updateSummary?.priceDifference
                                | formatNumber: '$' : false
                        }}
                        {{
                            'featured_details_updateCategory_price_confirmed_day'
                                | translate
                        }}
                        {{
                            'featured_details_updateCategory_price_confirmed_end'
                                | translate
                        }}
                    </span>
                </ng-template>
            </p>
            <fe-button
                [style]="'tertiary'"
                [btnClass]="'justify-content-center w-100'"
                [loading]="!!loadingBtn"
                [disabled]="confirmed"
                class="btn-update"
                (onClick)="update()"
            >
                {{
                    (confirmed
                        ? 'featured_details_updateCategory_selected'
                        : 'featured_details_updateCategory_4'
                    ) | translate
                }}
            </fe-button>
            <ng-container *ngIf="!loadingPrice; else loadingSkeleton">
                <p>
                    {{
                        (confirmed
                            ? 'featured_details_updateCategory_total_confirmed'
                            : 'featured_details_updateCategory_5'
                        ) | translate
                    }}
                    ${{ updateSummary?.total | formatNumber: '$' : false }}
                </p>
            </ng-container>

            <ng-template #loadingSkeleton>
                <p class="skeleton-text"></p>
            </ng-template>
        </div>
    </div>
    <div class="upgrade-promotion__confirm" role="status" aria-live="polite">
        <svg
            class="upgrade-promotion__check"
            viewBox="0 0 24 24"
            aria-hidden="true"
        >
            <circle cx="12" cy="12" r="12" />
            <path d="M7 12.5l3.2 3.2L17 9" />
        </svg>
        <span>
            {{ 'featured_details_updateCategory_confirmed' | translate }}
        </span>
    </div>
</section>
